module.exports = __webpack_public_path__ + "img/2024-02-13c_1.51ba811c.jpg";